import { useState, useEffect } from "react";
import Select, { type SingleValue } from "react-select";
import { MdClear } from "react-icons/md";

export interface SelectOption {
  label: string;
  value: string | number;
  icon?: string;
  is_active?: boolean | number | any;
}

export interface MySelectSimpleProps {
  options: SelectOption[] | any;
  value: string | number | null | any;
  onChange: (value: string | number | null) => void;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
}

const MySelectSimple: React.FC<MySelectSimpleProps> = ({
  options,
  value,
  onChange,
  placeholder = "Select...",
  disabled = false,
  isClearable = true,
}) => {
  const [selected, setSelected] = useState<SingleValue<SelectOption>>(null);

  useEffect(() => {
    if (value === null) {
      setSelected(null);
      return;
    }

    const current =
      options.find(
        (opt) => String(opt.value) === String(value)
      ) ?? null;

    setSelected(current);
  }, [value, options]);

  const handleChange = (opt: SingleValue<SelectOption>) => {
    setSelected(opt);
    onChange(opt?.value ?? null);
  };

  const handleClear = () => {
    setSelected(null);
    onChange(null);
  };

  return (
    <div className="w-full relative max-w-sm">
      <Select<SelectOption, false>
        options={options}
        value={selected}
        onChange={handleChange}
        placeholder={placeholder}
        isDisabled={disabled}
        classNamePrefix="react-select"
        isClearable={false}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />

      {isClearable && selected && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-red-500 hover:text-red-700"
        >
          <MdClear size={18} />
        </button>
      )}
    </div>
  );
};

export default MySelectSimple;